import { FelaCSS, colors, spacing } from '@bridebook/ui';

interface IStyles {
  container: FelaCSS;
  buttonWrap: FelaCSS;
  buttonContainer: FelaCSS;
  bottomInfo: FelaCSS;
  saveToShort: FelaCSS;
  socialWrapper: FelaCSS;
  button: FelaCSS;
}

const styles: IStyles = {
  container: {
    borderTop: `2px solid ${colors.space08}`,
    paddingVertical: 2,
    alignItems: 'center',
    flexShrink: 0,
    width: '100%',
    backgroundColor: colors.white,

    maxWidthMobile: {
      supportsSafeAreaInset: {
        paddingBottom: `calc(env(safe-area-inset-bottom) + ${spacing[2]})`,
      },
    },
  },

  buttonWrap: {
    paddingHorizontal: 3,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },

  buttonContainer: {
    flexGrow: 1,
  },

  bottomInfo: {
    paddingTop: 1,
    width: '100%',
    textAlign: 'center',
    fontDefault: 12,
    lineHeight: '1.2em',
    color: colors.space75,
  },

  saveToShort: {
    marginLeft: 2,
  },

  socialWrapper: {
    marginLeft: 2,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    gap: 4,
  },

  button: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    paddingHorizontal: 1,

    minWidthMobile: {
      padding: 0,
    },
  },
};

export default styles;
